import React, { useState, useEffect } from "react";

import '../style.css';
import { Select, Typography } from "antd";
import ToggleControl from "./ToggleControl";
import { CaretDownOutlined } from "@ant-design/icons";
import { getOffices } from "../Controller";
import SelectOffice from "./SelectOffice";

const tabs = ["Daily", "Weekly", "Monthly", "Yearly"];
const intervalPresets = {
  Daily: Array.from({ length: 7 }, (_, i) => `${i + 1} Day`),
  Weekly: Array.from({ length: 4 }, (_, i) => `${i + 1} Week`),
  Monthly: ["1 Month", "2 Months", "3 Months", "4 Months", "6 Months", "9 Months"],
  Yearly: Array.from({ length: 5 }, (_, i) => `${i + 1} Year`),
};
const {Option} = Select;

export default function Header({
  initialTab = "Monthly",
  onTabChange = () => {},
  onIntervalChange = () => {},
  onOfficeChange = () => {},
}) {
  const [activeTab, setActiveTab] = useState(initialTab);
  const [interval, setInterval] = useState(intervalPresets[initialTab][0]);
  const [offices, setOffices] = useState([]);
  const [selectedOfficeIds, setSelectedOfficeIds] = useState([]); // Selected office IDs

  useEffect (() => {
    const fetchOffices = async () => {
      // setLoading(true);
      try {
        const result = await getOffices();
        setOffices(result);
      } catch (err) {
        console.error(err);
        setOffices([]);
      } //finally {
      //  setLoading(false);
      //}
    };
    fetchOffices();
  }, [])
  

  useEffect(() => {
    setInterval(intervalPresets[activeTab][0]);
    onIntervalChange(intervalPresets[activeTab][0]);
  }, [activeTab]);

  const handleOfficeChange = (integerValues) => {
    setSelectedOfficeIds(integerValues);
    onOfficeChange(integerValues);
  };

  return (
    <div style={{display: 'flex', flexDirection: 'column', paddingTop: 1}}>
      <Typography style={{fontSize: 24, fontWeight: 400}}>
        Active Users Analytics
      </Typography>
      <Typography style={{fontSize: 14, fontWeight: 400, color: '#848696', marginTop: 7, marginBottom: 50}}>
        Track user engagement and growth metrics across different time periods
      </Typography>

      <SelectOffice  offices={offices} selectedOfficeIds={selectedOfficeIds} onOfficeChange={handleOfficeChange}/>

      {/* Bottom row */}
      <ToggleControl tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab} onTabChange={onTabChange}/>

      {/* Dropdown */}
      <div>  
        <Typography style={{fontSize: 18, fontWeight: 400, marginBottom: 10}}>
          Select Intervals to see details (defaults to 1 if not set)
        </Typography>
        <div className="select-container">
          <select
            value={interval}
            onChange={(e) => {
              setInterval(e.target.value);
              onIntervalChange(e.target.value);
            }}
            className="custom-select"
          >
            {intervalPresets[activeTab].map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}
